'use client';

import { env } from 'next-runtime-env';
import { useEffect, useRef, useState } from 'react';

import { postData } from '@/lib/utils/api';
import { IResponse } from '@/models';

const useGoftinoChat = () => {
  const [widgetSrc, setWidgetSrc] = useState<string | null>(null);
  const isRegisteredRef = useRef(false);
  const hasInitialized = useRef(false);

  const baseUrl = env('NEXT_PUBLIC_GOFTINO_BASE_URL') ?? '';
  const widgetId = env('NEXT_PUBLIC_GOFTINO_WIDGET_ID') ?? '';

  useEffect(() => {
    if (!baseUrl || !widgetId) return;

    const o = localStorage.getItem(`goftino_${widgetId}`);
    const url = `${baseUrl}widget/${widgetId}${o ? `?o=${o}` : ''}`;
    setWidgetSrc(url);
  }, [baseUrl, widgetId]);

  useEffect(() => {
    const handleReady = () => {
      if (hasInitialized.current) return;

      const goftino = (window as any).Goftino;
      if (goftino?.setWidget) {
        goftino.setWidget({
          hasIcon: false,
          cssUrl: 'https://saraa.asax.ir/assets/css/GoftinoCustomWidgetStyleV1.3.css',
        });
        hasInitialized.current = true;
      }
    };

    window.addEventListener('goftino_ready', handleReady);
    return () => {
      window.removeEventListener('goftino_ready', handleReady);
    };
  }, []);

  const openChat = async () => {
    const goftino = (window as any).Goftino;

    if (!goftino?.getUserId) return;

    const userId = goftino.getUserId();

    if (!userId || isRegisteredRef.current) {
      goftino.open();
      return;
    }

    try {
      await postData<string, IResponse>(`support/chat`, { data: userId, version: 'v2' });
      isRegisteredRef.current = true;
    } catch (error: any) {
      if (error) console.error('registration failed!', { error });
    }

    goftino.open();
  };

  //TODO
  // const logoutChat = () => {
  //   const goftino = (window as any).Goftino;
  //   if (goftino?.unsetUserId) {
  //     goftino.unsetUserId();
  //   } else {
  //     console.warn('Goftino unsetUserId not available.');
  //   }
  // };

  const logoutChat = () => {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('goftino')) {
        localStorage.removeItem(key);
      }
    });
  };

  return { widgetSrc, openChat, logoutChat };
};

export default useGoftinoChat;
